import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { DocumentMetadata, MetadataType } from 'src/app/models/documentMetadata';

@Component({
  selector: 'app-document-nice-classes',
  templateUrl: './document-nice-classes.component.html',
  styleUrls: ['./document-nice-classes.component.scss']
})
export class DocumentNiceClassesComponent implements OnInit, OnChanges {
  @Input() metadata?: DocumentMetadata[] = [];
  @Input() niceClassification: number[] = [];
  @Input() productsServices?: {
    ref: string;
    label?: string;
    classNumber: number;
    trademark: string;
  }[] = [];
  @Input() shown: boolean = false;
  @Input() filter?: number[];
  niceClasses: {
    value: number;
    confidence: number;
    isCandidate: boolean;
  }[] = []
  limit: number = 3;


  constructor(
  ) { }

  ngOnInit(): void {
    this.populateConfidence()
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.niceClassification = this.niceClassification.sort();
    this.populateConfidence()
  }

  populateConfidence() {
    this.niceClasses = this.niceClassification.map(nice => ({
      value: nice,
      confidence: this.getConfidence(nice),
      isCandidate: this.isCandidate(nice)
    }))
  }

  getConfidence(niceClass: number) {
    return (this.metadata?.find(datum => datum.type === MetadataType.NICE_CLASS && datum.value === `${niceClass}`)?.confidence ?? 0) * 100
  }

  isCandidate(niceClass: number) {
    return this.productsServices?.find(ps => ps.classNumber === niceClass) === undefined;
  }

  toggle() {
    if (this.limit === 3) {
      this.limit = this.niceClassification.length;
    } else {
      this.limit = 3;
    }
  }

  hasFilters(): boolean {
    return this.filter && this.filter.length > 0 ? true : false;
  }

  filtered() {
    if (!this.hasFilters())
      return this.niceClasses;
    return this.niceClasses.filter((n) => this.filter?.includes(n.value))
  }
}
